import { render, staticRenderFns } from "./register-agreement.vue?vue&type=template&id=1eb6d51c&"
import script from "./register-agreement.vue?vue&type=script&lang=js&"
export * from "./register-agreement.vue?vue&type=script&lang=js&"
import style0 from "./register-agreement.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports